import { memo } from 'react';
import { useGetSubscription } from '@/api/subscription/queries';
import { Separator } from '@/components/ui/separator';
import { Sidebar, SidebarContent, SidebarFooter, SidebarHeader } from '@/components/ui/sidebar';
import { NavHeader } from './nav-header';
import { NavInfo } from './nav-info';
import { NavMain } from './nav-main';
import { NavSecondary } from './nav-secondary';
import { NavUser } from './nav-user';
import { OrganizationSelect } from './organization-selector';
import { ProjectsSelect } from './project-selector';
import type { Layout } from './types';

type Props = { layout: Layout } & React.ComponentProps<typeof Sidebar>;

export const AppSidebar = memo(function AppSidebar({ layout, ...props }: Props) {
  const { data } = useGetSubscription();

  return (
    <Sidebar variant="inset" collapsible="icon" {...props}>
      <SidebarHeader>
        <NavHeader plan={data?.subscriptionPlan} />
        {layout === 'global' ? <OrganizationSelect /> : null}
        {layout === 'projects' ? <ProjectsSelect /> : null}
      </SidebarHeader>
      <SidebarContent>
        <NavMain layout={layout} isFree={data?.isFree} />
        <NavSecondary />
        <Separator />
        <NavInfo />
      </SidebarContent>
      <SidebarFooter>
        <NavUser />
      </SidebarFooter>
    </Sidebar>
  );
});
